import { Box, Stack } from '@ace-clublabs/shared-component-library';
import { type ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import ProgressBar from './ProgressBar';

interface WizardStep {
  content: ReactNode;
  disableNext?: boolean;
}

interface MobileWizardProps {
  steps: WizardStep[];
  onClickContinue: () => void;
}

const MobileWizard: React.FC<MobileWizardProps> = ({
  steps,
  onClickContinue,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const state = (location.state as { step?: number }) || {};
  const step = state.step ?? 0;

  useEffect(() => {
    if (state.step == null) {
      navigate(location.pathname, {
        replace: true,
        state: { step: 0 },
      });
    }
  }, [location.pathname, state.step, navigate]);

  const handleNext = () => {
    if (step + 1 < steps.length) {
      navigate(location.pathname, { state: { step: step + 1 } });
    } else {
      onClickContinue();
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Stack
      direction='column'
      sx={{
        width: '100%',
        height: '100%',
      }}
      data-testid='mobile-wizard'
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflowY: 'auto',
          backgroundColor: 'grey.50',
          pb: '68px',
        }}
      >
        {steps[step].content}
      </Box>
      <ProgressBar
        displayBackButton
        onClickContinue={handleNext}
        onClickBack={handleBack}
        disableNavigation
        buttonDisabled={steps[step].disableNext}
        fixed
      />
    </Stack>
  );
};

export default MobileWizard;
